<div class="row">
    <div class="col-sm-9">
      <div class="booking_ht">
  <!-- <sm-title-bar pageTitle="All upcoming appointments"></sm-title-bar> -->
  <sm-title-bar pageTitle="All upcoming activity" [backWithParams]="true"></sm-title-bar>

  </div>
  </div>
  <div class="col-sm-3">
    <!-- <div class="search_bar_custom">
      <mat-form-field appearance="outline">
          <mat-label>Search</mat-label>
          <input matInput placeholder="Search for services">
          <button mat-icon-button matSuffix>
              <mat-icon>search</mat-icon>
          </button>
      </mat-form-field>
  </div> -->
  </div>
  </div>
  
  <mat-card *ngIf="!loader && upcomingAppointmentsData.length > 0">
      <div class="rounded-3 bg-light">
        <sm-data-table-for-appointments [columnHeaders]="tableDisplayColumns" 
                       [showImageColumn]="true" 
                       [imageTemplate]="image" 
                       [dataSource]="upcomingAppointmentsData" 
                      [showMenuButton]="true"
                      [menuDropdownTemplate]="menuTemplate"
                       [showPagination]="true" 
                       [itemsPerPage]="25"
                              [rowClickHandler]="rowClickHandler"
                       >
        </sm-data-table-for-appointments>
      </div>
    </mat-card>
    
    <ng-template #menuTemplate let-rowvalue>
      <!-- OPTION MENUS FOR BOOKINGS -->
       <div *ngIf="rowvalue.data_type == 1">
         <button mat-menu-item (click)="bookingDetails(rowvalue)">
             <mat-icon class="material-icons-outlined">info</mat-icon>
             <span>Booking details</span>
         </button>
        <!-- <button mat-menu-item (click)="confirmBooking(rowvalue)" *ngIf="(((rowvalue.appointment_status == 0 || rowvalue.appointment_status == 1 || rowvalue.appointment_status == 2) && (rowvalue.customer_hash && rowvalue.customer_hash != 'null')))">
          <mat-icon class="material-icons-outlined">check_circle</mat-icon>
          <span>Confirm booking</span>
      </button>
      <button mat-menu-item (click)="cancelBooking(rowvalue)" *ngIf="(((rowvalue.appointment_status == 0 || rowvalue.appointment_status == 1 || rowvalue.appointment_status == 2 || rowvalue.appointment_status == 5)&& rowvalue.is_owner == 1))">
          <mat-icon class="material-icons-outlined">cancel</mat-icon>
          <span>Cancel booking</span>
      </button>
      <button mat-menu-item *ngIf="(!rowvalue.customer_hash || rowvalue.customer_hash == 'null')&& rowvalue.is_owner == 1" (click)="deleteBooking(rowvalue)">
        <mat-icon class="material-icons-outlined">delete</mat-icon>
        <span>Delete booking</span>
      </button> -->
  
       </div>
  
    <!-- OPTION MENUS FOR QUERIES -->
  
  
    <div *ngIf="rowvalue.data_type == 2">
      <!-- <button mat-menu-item>
        <mat-icon class="material-icons-outlined">info</mat-icon>
        <span>Query details</span>
        </button>
        <button mat-menu-item>
         <mat-icon class="material-icons-outlined">hourglass_top</mat-icon>
         <span>Mark as in-progress</span>
         </button>
         <button mat-menu-item >
         <mat-icon class="material-icons-outlined">task_alt</mat-icon>
         <span>Mark as enrolled</span>
         </button> -->
         <button mat-menu-item (click)="bookingDetails(rowvalue)">
          <mat-icon class="material-icons-outlined">info</mat-icon>
          <span>View details</span>
          </button>
         <!-- <button mat-menu-item [disabled]="true">
         <mat-icon class="material-icons-outlined">check_circle</mat-icon>
         <span>mark as present</span>
         </button>
         <button mat-menu-item [disabled]="true">
         <mat-icon class="material-icons-outlined">cancel</mat-icon>
         <span>mark as absent</span>
         </button> -->
  <!--       
         <button mat-menu-item>
         <mat-icon class="material-icons-outlined">delete</mat-icon>
         <span> Delete query</span>
         </button> -->
        
  
    </div>
   
    </ng-template>
    
  
    
    <ng-template #image let-objValue>
      <img

        [src]="
          objValue['customer_thumb_image'] !== null && objValue['customer_thumb_image'] !== 'null' && objValue['customer_thumb_image'] !== ''
            ? objValue['customer_thumb_image']
            : '../../../../../assets/images/user-avatar.svg'
        "
        onerror="this.src='../../../../../assets/images/user-avatar.svg'"
        class="img-fluid rounded-circle"
      />
    </ng-template>